module.exports = __webpack_public_path__ + "static/img/stockImg.63b14c58.jpg";